import { useMutation, useQuery } from "@apollo/client";
import { useCallback } from "react";
import { toast } from "react-toastify";
import { GENERATE_LEDGER } from "../apollo/mutations";
import { GET_CUSTOMERS, LIST_USERS_BY_ROLE } from "../apollo/queries";
import useFilters from "../core/hooks/useFilters";
import { getStates } from "../utils/country";
import { downloadPDF, getSelectedStoreDetails } from "../utils/helperFunctions";

const countryValues = {
  country_id: "US",
  label: "🇺🇸 United States",
  value: "United States",
};

const useCustomer = (selectedRep, selectedState, selectedCity) => {

  const { search, debouncedValue, onChange, pagination, handlePageChange } =
    useFilters();

  const { loading, error, data, refetch } = useQuery(GET_CUSTOMERS, {
    variables: {
      input: {
        limit: pagination.limit,
        pageStart: pagination.pageStart,
        store_id: getSelectedStoreDetails("id"),
        name: debouncedValue,
        user_id: selectedRep?.value,
        state: selectedState?.value,
        city: selectedCity?.value,
      },
    },
    fetchPolicy: "cache-and-network",
  });

  const [generateSheet] = useMutation(GENERATE_LEDGER, {
    onCompleted: (data) => downloadPDF(data?.generateLedger?.data?.pdf, `${data?.generateLedger?.data?.customer_name} - PAYMENT SHEET`),
    onError: (err) => {
      console.error("Error generating PDF:", err.message);
    },
  });

  if (error) {
    console.log("Error While Getting Brands", error);
  }

  const { data: repsData, error: repsError } = useQuery(LIST_USERS_BY_ROLE, {
    variables: {
      role: ["Representative"],
    },
    fetchPolicy: "cache-and-network",
  });

  if (repsError) {
    console.log("Error While Getting Representatives", repsError);
  }

  const representatives =
    repsData?.listUserByRole?.map((user) => ({
      label: user.full_name,
      value: user.id,
    })) || [];

  const downloadSheet = useCallback((id) => {

    let payload = {
      variables: {
        customerId: id,
      },
    };

    toast.promise(generateSheet(payload), {
      pending: "Generating Sheet ...",
      success: "Sheet Generated Successfully",
    });

  }, []);

  return {
    values: {
      allCustomer: data?.allCustomer || [],
      total: data?.allCustomer?.total || 0,
      loading,
      search,
      representatives,
      states: getStates(countryValues?.country_id),
      pageValues: {
        current: pagination.pageStart + 1,
        pageSize: pagination.limit,
        total: data?.allCustomer?.total || 0,
      },
    },
    functions: {
      onChange,
      refetch,
      handlePageChange,
      downloadSheet
    },
  };
};

export default useCustomer;
